import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import ProjectShowcase from "@/pages/ProjectShowcase";
import ProjectDetail from "@/pages/ProjectDetail";
import Contact from "@/pages/Contact";
import Placeholder from "@/pages/Placeholder";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/showcase" element={<ProjectShowcase />} />
          <Route path="/projects-showcase" element={<ProjectShowcase />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route
            path="/industries"
            element={<Navigate to="/services" replace />}
          />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="*"
            element={
              <Placeholder
                title="Page Not Found"
                subtitle="The page you are looking for doesn't exist. Let's get you back on track."
              />
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
